'use strict'
import Vuex from 'vuex'
import Vue from 'vue'
import * as d3 from 'd3'

import utils from '../utils'
import helpers from './helpers'
import data from './data'

import structs from '../structures'

import  backendModule from './backend'

Vue.use(Vuex)


export default new Vuex.Store({
  modules:{
    backend : backendModule
  },
  state: {
    node_thickness: 35.0,
    value_scale: 10.0,
    stroke_width: .5,

    column_separation: 950.0,
    global_scale_y: .45,
    global_scale_x: .4,

    squash: false,
    accum: true,
    group_naics: false,
    default_group_separation: 40.0,
    default_node_padding: 40.00,
    group_separation: 40.0,
    node_padding: 40.00,

    mousepos:{x:0,y:0},

    cur_node: null,
    up_down: null,
    export_layer:null,

    nodes: {},
    links: {},
    node_by_name: {},

    make_passthroughs:false,
    crossover_cache:[],
    passthrough_cache:[],
    ghosts:false,
    ghost_factor:1.,
    ghost_diff:0.,

    search_term:"",
    selected_tags:[],
    doSorting:true,
    dirty:false,
    colorTypes: [
      'Energy Source', 'Data Source', 'Grouping'
    ],
    datasets: [
      'All datasets','RECS', 'MECS','EIA-MER','CBECS','FEMP','NHTS'
    ],
    color_type: 'Data Source',
    dataset: 'All datasets',
    palettes: {
      "6":["rgb(228,92,117)","rgb(255,185,87)","rgb(133,215,235)","rgb(144,255,137)","rgb(164,138,225)","rgb(205,58,155)","rgb(255,192,169)","rgb(139,148,125)","rgb(226,61,127)","rgb(232,73,98)","rgb(91,63,193)","rgb(239,174,211)","rgb(255,255,17)"],
      "5":["rgb(105,105,105)","rgb(90,110,175)","rgb(0,96,0)","rgb(204,0,0)","rgb(255,215,0)","rgb(144,238,144)","rgb(145,18,145)","rgb(0,0,255)","rgb(145,90,18)"],
    },
    colorset:"6",
    loss_color: "hsl(35,100%,32%)",
    energy_services_color: "hsl(135,60%,32%)",
    resolution: 0.001,
    sigfig: 2
  },
  getters: {
    raw_nodes: (state)=>{
      return utils.flatten(Object.values(state.nodes),'children')
    },
    columns: (state)=>{
      //nest the nodes by column
      var bb =  d3.nest().key( (d)=>{ return d.column; }).entries(Object.values(state.nodes)).map( (d) => {return d.values; })

      //then get them in order in the array
      bb = bb.sort( (c1,c2)=>{return c1[0].column - c2[0].column} )

      function sorting(a) {

        if (a.is_reserves){
          return -9e29
        }

        var g_func = a.grouping_function()

        if(g_func!=null){
          return g_func()
        }


        if(!a.sector_amts || d3.sum(Object.values(a.sector_amts))<1e-9) {
          return -9e19
        }
        if (a.name.includes("coal production") ){
          return 1e1
        }
        if (!a.children.length) return -1e8

        return 1e-7*a.maxSector()
      }


      var cols = {}
      bb.forEach( (column, cid) => {
        //sort by group and value
        column.sort((a,b)=>{ return sorting(b)-sorting(a)})

        var split = d3.nest()
		        .key( (d)=>{ return sorting(d) })
		        .entries(column)
		        .map( (d)=>{ return d.values; });

        var o = {}

        split.forEach( (group,gid) => {
          o[gid]={}
          group.forEach( (n,id) => {
            o[gid][id]=n
          } )

        })

        cols[cid-1]=o
      })

      Object.values(state.nodes).forEach( cn=> {
        cn.children.forEach(n=>{
          var sn = {}
          var sl = {}
          utils.upstream(n,sl,sn)
          n.upstream = Object.keys(sn)
          sn = {}
          sl = {}
          utils.downstream(n,sl,sn)
          n.downstream = Object.keys(sn)
        })
      })

      return cols
    },
    colors: (state) =>{
      return state.palettes[state.colorset].map(d3.color)
    },
    node_color: (state,getters) => (node) => {
      var vals;
      var cols = getters.colors

      if (state.color_type == "Energy Source" || node.column < 3){
        vals = node.source_amts
        var ks = Object.keys(vals)
        var mx = ks.reduce((a, b) => vals[a] > vals[b] ? a : b);
        cols = state.palettes['5'].map(d3.color)
        return cols[ks.indexOf(mx)%cols.length]
      }else if (1 || state.color_type == "Data Source"){
        vals = node.sector_amts
      }

      if (0 && state.color_type == "Grouping"){
        var group_val = ()=>{
          var a = node
          if (a.name.includes("*energy services*")) return 0
        if (a.name.includes("*waste*")) return 1
          if (a.name.includes("overhead")) return 2

          if (a.get_tags().indexOf("housing") >=0) {
            return 3
          }
          if (a.get_tags().indexOf("food") >=0) {
            return 4
          }
          if (a.get_tags().indexOf("health") >=0) {
            return 5
          }
          if (a.get_tags().indexOf("stuff") >=0 || a.get_tags().indexOf("transport-stuff") >=0) {
            return 6
          }
          if (a.get_tags().indexOf("services") >=0) {
            return 7
          }
          return 8
        }

        return cols[group_val()%cols.length]
      }


      var ks = Object.keys(vals)
      if(d3.sum(Object.values(vals))<1e-3){
        return cols[cols.length-1]
      }
      var mx = ks.reduce((a, b) => vals[a] > vals[b] ? a : b);
      return cols[ks.indexOf(mx)%cols.length]
    }
  },
  actions:{
    load_base_data(context,payload){
      var base_data = data.load_csvs(payload.nodes,payload.links)
      context.state.nodes=base_data.compoundNodes
      context.state.links=base_data.links
      context.state.node_by_name=base_data.node_by_name
      context.dispatch("accumulate")
      context.dispatch("create_passthroughs")
      context.dispatch("contract_naics")
      context.commit("runInitialLayout",context.getters)
      context.commit("resort",context.getters)
      context.commit("relax",context.getters)
    },
    ////////////////////// PASSTHROUGHS //////////////////////
    toggle_passthroughs(context){
      context.state.make_passthroughs=!context.state.make_passthroughs
      if(context.state.make_passthroughs)
        context.dispatch('create_passthroughs')
      else
        context.dispatch('eliminate_passthroughs')
      context.commit('relax',context.getters)
    },

    eliminate_passthroughs(context){
      context.state.make_passthroughs=false
      context.state.crossover_cache.forEach( l =>{
        var nl = utils.add_link(context.state.links,l.source,l.target,l.value)
        Vue.set(context.state.links,nl.index,nl)
      })
      context.state.passthrough_cache.forEach( l =>{
        l.source.source_links.splice(l.source.source_links.indexOf(l),1)
        l.target.target_links.splice(l.target.target_links.indexOf(l),1)
        Vue.delete(context.state.links,l.index)
      })

      Object.values(context.state.nodes).filter(cn=>cn.name.includes("(passthrough")).forEach( cn=>{
        Vue.delete(context.state.nodes,cn.index)
        Vue.delete(context.state.node_by_name,cn.name)
      })

      context.state.crossover_cache=[]
      context.state.passthrough_cache=[]
    },

    create_passthroughs(context){
      context.state.make_passthroughs=true
      var bad=[]
      Object.values(context.state.nodes).forEach(cn=>{
        cn.children.forEach( n=>{
          if (!n.is_reserves)
            n.source_links.forEach(l=>{ if((l.target.column - n.column > 1) && l.value>1e-5) bad.push(l) })
        })
      })
      context.state.crossover_cache=bad
      bad.forEach(l=>{
        var n1 = l.source
        var n2 = l.target
        //strip existing link
        n1.source_links.splice(n1.source_links.indexOf(l),1)
        n2.target_links.splice(n2.target_links.indexOf(l),1)
        Vue.delete(context.state.links,l.index)

        var lossy=n2.name.includes("*waste")
        var prev = n1
        for(var i=1;i<(n2.column-n1.column);++i){
          var exists = context.state.node_by_name[n1.name+" (passthrough"+i.toString()+")"]
          if (!exists) {
            context.commit("duplicateNode",{node:n1,name:"passthrough"+i.toString()}) //ugh
            var nn = context.state.node_by_name[n1.name+" (passthrough"+i.toString()+")"]
            nn.source_links = []
            nn.target_links = []
            nn.column=prev.column+1
          }
          var nn = context.state.node_by_name[n1.name+" (passthrough"+i.toString()+")"]

          var nl = utils.add_link(context.state.links,prev,nn,l.value)
          nl.is_loss=lossy
          context.state.passthrough_cache.push(nl)
          Vue.set(context.state.links,nl.index,nl)
          prev = nn
        }
        var nl = utils.add_link(context.state.links,prev,n2,l.value)
          nl.is_loss=lossy
        context.state.passthrough_cache.push(nl)
        Vue.set(context.state.links,nl.index,nl)
      })
    },

    ////////////////////// NAICS //////////////////////
    toggle_naics(context){
      context.state.group_naics=!context.state.group_naics
      if(context.state.group_naics)
        context.dispatch('contract_naics')
      else
        context.dispatch('expand_naics')
    },

    contract_naics(context){
      context.state.group_naics=true
      var ff = Object.values(context.state.nodes).filter(cn =>{
        var out = false;
        cn.children.forEach(n=>{
          if(n.naics_code != null && n.naics_code.length>3)
            out=true
        })
        return out
      })

      var boxes = {}
      ff.forEach( cn=>{
        cn.children.forEach(n=>{
          if(!boxes[n.column])
            boxes[n.column]={}
          if(n.naics_code){
            var header = n.naics_code.toString().slice(0,3)
            if(!boxes[n.column][header]) boxes[n.column][header]=n
            else{
              utils.move_node(n,boxes[n.column][header],'naics')
              n.grouped_naics=true
            }
          }
        })
      })
      context.commit("relax",context.getters)
    },

    expand_naics(context){
      context.state.group_naics=false
      var revert = []
      Object.values(context.state.nodes).forEach(cn =>{
        cn.children.forEach(n=>{
          if(n.grouped_naics){
            revert.push(n)
          }
        })
      })

      revert.forEach( n=>{
        delete n.grouped_naics
        utils.revert_node(n,'naics')
      })

      context.commit("relax",context.getters)
    },
    toggle_ghost_quads(context){
      context.state.ghosts=!context.state.ghosts
      if(context.state.ghosts){
        context.dispatch("enable_ghost_quads")
      }else{
        context.dispatch("disable_ghost_quads")
      }
    },
    disable_ghost_quads(context){
      var filter1=['primary solar/pv',
                   'primary nuclear',
                   'primary wind',
                   'primary hydroelectric']
      var elec = context.state.node_by_name['electricity']
      var g1 = elec.target_links.filter(l=>filter1.indexOf(l.source.name)>=0)
      var g2 = elec.target_links.filter(l=>l.source.name.includes("geothermal"))
      g1.forEach(l=>{
        l.value*=1./(1.-.65)
      })
      g2.forEach(l=>{
        l.value*=1./(1.-.9)
      })

      var ghost = context.state.node_by_name['ghost quads']
      ghost.target_links.forEach(l=>{
        l.source.source_links.splice(l.source.source_links.indexOf(l),1)
        Vue.set(l,'value',0.) //hack to update before delete
        delete context.state.links[l.index]
      })

      elec.source_links.filter(l=>l.target.name.includes("electricity loss")).forEach(l=>{
        var vv = l.value*1./context.state.ghost_factor
        Vue.set(l,'value',vv)
        console.assert(l.target.source_links.length=1)
        Vue.set(l.target.source_links[0],'value',vv)
      })

      var waste1=context.state.node_by_name["residential electricity loss"].source_links[0].target
      while(waste1.source_links.length){
        waste1.source_links[0].value+=context.state.ghost_diff
        waste1=waste1.source_links[0].target
      }

      ghost.target_links=[]
      context.commit("relax",context.getters)
    },
    enable_ghost_quads(context){
      var filter1=['primary solar/pv',
                   'primary nuclear',
                   'primary wind',
                   'primary hydroelectric']
      var elec = context.state.node_by_name['electricity']
      var g1 = elec.target_links.filter(l=>filter1.indexOf(l.source.name)>=0)
      var g2 = elec.target_links.filter(l=>l.source.name.includes("geothermal"))
      var prev = elec.get_tgt_value()
      g1.forEach(l=>{
        var nl=utils.add_link(context.state.links,l.source,context.state.node_by_name['ghost quads'],l.value*.65)
        Vue.set(context.state.links,nl.index,nl)
        l.value*=(1.-.65)
      })
      g2.forEach(l=>{
        var nl = utils.add_link(context.state.links,l.source,context.state.node_by_name['ghost quads'],l.value*.9)
        Vue.set(context.state.links,nl.index,nl)
        l.value*=(1.-.9)
      })
      var after = elec.get_tgt_value()
      var diff = prev-after
      var losses= elec.source_links.filter(l=>l.target.name.includes("electricity loss"))
      var total_loss=d3.sum(losses,l=>l.value)
      context.state.ghost_factor = (1-diff/total_loss)

      elec.source_links.filter(l=>l.target.name.includes("electricity loss")).forEach(l=>{
        var vv = l.value*context.state.ghost_factor
        Vue.set(l,'value',vv)
        console.assert(l.target.source_links.length=1)
        Vue.set(l.target.source_links[0],'value',vv)
      })


      var waste1=context.state.node_by_name["residential electricity loss"].source_links[0].target
      context.state.ghost_diff = (1.-context.state.ghost_factor)*waste1.source_links[0].value

      while(waste1.source_links.length){
        waste1.source_links[0].value-=context.state.ghost_diff
        waste1=waste1.source_links[0].target
      }

      Vue.set(context.state.node_by_name['ghost quads'],'column',2)
      context.commit('relax',context.getters)
    },

    ////////////////////// ACCUMULATION //////////////////////
    toggle_accum(context){
      context.state.accum=!context.state.accum

      if(context.state.accum){
        context.dispatch("accumulate")
      }else{
        context.dispatch("deaccumulate")
      }
    },
    accumulate(context){
      var cols = context.getters.columns
      var mx = Object.keys(cols).length-1
      //move direct ag_name targets to indirect/accumulated node in next column
      function retarg(ag_name,loss){
        Object.values(context.state.links).forEach( l=>{
          if (l.target.name.includes(ag_name)){
            var n = context.state.node_by_name[ag_name+"_"+(l.source.column+1).toString()]
            utils.re_target(l,n)
          }
        })
      }
      retarg("*waste*",true)
      retarg("*energy services*",false)
      //accumulate aggregates across columns
      function accum(node_name){
        for(var i =1; i < mx; ++i){
          var src = context.state.node_by_name[node_name+"_"+ (i).toString()]
          var tgt = context.state.node_by_name[node_name+"_"+ (i+1).toString()]
          if(!src || !tgt)
            break //TODO: THIS IS WEIRD...SOME BUG HIDDEN SOMEWHERE MAKES THIS NECESSARY
          var id = utils.get_new_index(context.state.links)
          var l =new structs.Link(id,src,tgt,src.get_value(),"",true)
          src.source_links.push(l)
          tgt.target_links.push(l)
          Vue.set(context.state.links,id,l)
        }
      }
      accum("*waste*")
      accum("*energy services*")
      context.commit("resort",context.state)
      context.commit("runInitialLayout",context.getters)
    },
    tag_accumulate(context){
      var cols = context.getters.columns
      var mx = Object.keys(cols).length-1

      var seltags = context.state.selected_tags
      seltags.forEach(t=>{
        var specials = ["*"+t+" waste*","*"+t+" services*"]
        var hash = utils.hashCode(t)

        //make nodes
        specials.forEach(s=>{
          var n = new structs.Node()
          n.name = s
          var nid = utils.get_new_index(context.state.nodes)
          n.index=nid
          var new_cn = new structs.CompoundNode([n])
          new_cn.grouping_function = ()=>{return ()=>{return hash}}
          n.parent = new_cn
	        new_cn.index = nid
          context.state.nodes[nid]=new_cn
          context.state.node_by_name[s]=n
        })

        var nlinks = []
        Object.values(context.state.links).forEach( l=>{
          var towaste = l.target.name.includes("*waste*"),
              toservices = l.target.name.includes("*energy services*"),
              toprocess = (l.target.name.includes("process energy") || l.target.name.includes("non-process energy"))
          if(towaste || toservices || toprocess){
            var kk = Object.keys(l.source.tags)
            var relevant_tags = kk.filter(tt=>t==tt)
            if (relevant_tags.length > 0){
              var ntarg = context.state.node_by_name[towaste?specials[0]:specials[1]]
              var amt = l.source.tags[relevant_tags[0]]
              if (amt!=0){
                var nval = l.value*amt
                l.value*=(1.-amt)
                nlinks.push({'src':l.source,'targ':ntarg,'val':nval})
              }else{
                utils.re_target(l,ntarg)
              }
            }
          }
        })

        nlinks.forEach(obj=>{
          var nl = utils.add_link(context.state.links,obj.src,obj.targ,obj.val)
          context.state.links[nl.index]=nl
        })

        //create our carrythrough nodes
        function make_accumulated_nodes(node_name){
          var mx_id = utils.get_new_index(context.state.nodes)
          for(var i =0; i < mx-1; ++i){
            var id = mx_id+i
            var name =node_name+"_"+ (i+1).toString()
            var n = new structs.Node()

            n.index=id
            n.tags={}
            n.copyObject({"name":name,"column":(i+1)})
            n.datasource = ()=>{return ["implicit"]}
            var new_cn = new structs.CompoundNode([n])
            new_cn.grouping_function = ()=>{return ()=>{return hash}}
            n.parent = new_cn
	          new_cn.index = id
            context.state.nodes[id]=new_cn
            context.state.node_by_name[name]=n
          }
        }
        specials.map(make_accumulated_nodes)

        Object.values(context.state.links).forEach( l=>{
          if (l.target.name.includes('*'+t)){
            var n = context.state.node_by_name[l.target.name+"_"+(l.source.column+1).toString()]
            utils.re_target(l,n)
          }
        })

        //accumulate aggregates across columns
        function accum(node_name){
          for(var i =1; i < mx; ++i){
            var src = context.state.node_by_name[node_name+"_"+ (i).toString()]
            var tgt = context.state.node_by_name[node_name+"_"+ (i+1).toString()]
            if(!src || !tgt)
              break //TODO: THIS IS WEIRD...SOME BUG HIDDEN SOMEWHERE MAKES THIS NECESSARY
            var id = utils.get_new_index(context.state.links)
            var l =new structs.Link(id,src,tgt,src.get_value(),"",true)
            src.source_links.push(l)
            tgt.target_links.push(l)
            Vue.set(context.state.links,id,l)
          }
        }
        specials.map(accum)

      })
      context.commit("resort")
      context.commit("relax",context.getters)
    },

    deaccumulate(context){
      var cols = context.getters.columns
      var mx = Object.keys(cols).length-1

      //move all ag_name links to single ag_name node
      function retarg(ag_name,loss){
        Object.values(context.state.links).forEach( l=>{
          if (!(l.source.name.includes("*waste*") || l.source.name.includes("*energy services*")) && l.target.name.includes(ag_name+"_"+(l.source.column+1).toString())){
            var n = context.state.node_by_name[ag_name]
            utils.re_target(l,n)
          }
        })
      }

      retarg("*waste*",true)
      retarg("*energy services*",false)


      //remove all accumulated links
      function deaccum(node_name){
        for(var i =1; i < mx-1; ++i){
          var src = context.state.node_by_name[node_name+"_"+ (i).toString()]
          var tgt = context.state.node_by_name[node_name+"_"+ (i+1).toString()]

          var l = src.source_links.find( l=>{return l.target == tgt})

          console.assert(l!=null)
          src.source_links.splice(src.source_links.indexOf(l),1)
          tgt.target_links.splice(tgt.target_links.indexOf(l),1)

          Vue.delete(context.state.links,l.index)
          delete context.state.links[l.index]
        }
      }

      deaccum("*waste*")
      deaccum("*energy services*")

      context.commit("runInitialLayout",context.getters)
      context.commit("resort",context.state)
    },


    regroup(context){
      var payload = context.state.selected_tags
      /*
      function groupsort(a) {
        if (a.name.includes("*waste*")) return 9e9
        if (a.name.includes("*energy services*")) return -9e9
        var t = a.get_tags() //array of names
        if (!t.length)
          return 0
        var relevant = t.filter(tag=>payload.includes(tag))
        if (relevant.length)
          return utils.hashCode(relevant[0])
        return 0
      }
      */

      var curnodes = Object.values(context.state.nodes)
      curnodes.forEach ( cn => {
        cn.children.forEach (n => {
          //find all node tags in selected groupings
          var relevant_tags = Object.keys(n.tags).filter(t=>payload.includes(t))
          if (relevant_tags.length > 1){

            //check if we have fractional tags
            if(d3.sum(Object.values(n.tags))>0){
              var remainder = 1. - d3.sum(Object.keys(n.tags),k=>{return relevant_tags.includes(k) ? n.tags[k] : 0})
              relevant_tags.forEach( t=>{
                //context.commit('duplicateNode',{node:n,name:t})
                //delete c.tags[t]
              })
            }
          }
        })
      })

      /*
      var scl = payload.scl
      base_n.source_links.forEach( l=>{
        var lid = utils.get_new_index(state.links)
        var new_l = Object.assign(Object.create(Object.getPrototypeOf(l)),l)
        new_l.index = lid
        new_l.source=new_n
        new_l.value *= scl
        new_n.source_links = [...new_n.source_links,new_l]
        l.target.target_links = [...l.target.target_links,new_l]
        Vue.set(state.links,lid,new_l)
      })

      base_n.target_links.forEach( l=>{
        var lid = utils.get_new_index(state.links)
        var new_l = Object.assign(Object.create(Object.getPrototypeOf(l)),l)
        l.source.source_links = [...l.source.source_links,new_l]
        new_l.value *= scl
        new_l.index = lid
        new_l.target=new_n
        new_n.target_links = [...new_n.target_links,new_l]
        Vue.set(state.links,lid,new_l)
      })

      if(payload.fix){
        helpers.fixup_group(state,grp)
        helpers.fixup_column(state,state.columns[new_n.column])
      }
      */
      /*
      var cols = {}
      var cur = Object.values(context.getters.columns)
      cur.forEach( (c, id) => {
        var column = []
        Object.values(c).forEach(s=>{
          Object.values(s).forEach(n=>{column.push(n)})
        })

        //sort by group and value
        column.sort((a,b)=>{ return groupsort(b)-groupsort(a)})

        var split = d3.nest()
		        .key( (d)=>{ return groupsort(d) })
		        .entries(column)
		        .map( (d)=>{ return d.values; });

        var o = {}

        split.forEach( (group,gid) => {
          group.forEach( (n) => {Vue.set(n,'group_id',gid) } )
          o[gid]=group
        })
        cols[id]=o
      } )
      */

      /*
      Object.values(context.getters.columns).forEach( (column) =>{
        Object.values(column).forEach( (a)=>{
          var vals = Object.values(a)
          var firstn = vals[0]
          vals.forEach( (n,id)=>{
            if (id>0) {
              n.children.forEach( c=> { utils.move_node(c,firstn.children[0]) })
            }
          })
        })
      })
      */

      //context.state.color_type = 'Grouping'

      context.commit('relax',context.getters)
    },


    toggle_squash(context){
      context.state.squash=!context.state.squash

      if(context.state.squash){
        context.state.node_padding=1e-10
        context.state.group_separation=1e-10
        context.state.value_scale*=2
        context.commit("relax",context.getters)
      }else{
        context.state.node_padding=context.state.default_node_padding
        context.state.group_separation=context.state.default_group_separation
        context.state.value_scale/=2
        context.commit("relax",context.getters)
      }
    },
  },

  mutations: {
    set_mouse_pos (state,payload){
      state.mousepos = payload
    },
    set_resolution: (state,payload) =>{
      state.resolution = payload.val
      Object.values(payload.getters.columns).forEach( (column) =>{
        Object.values(column).forEach( (group,gid)=>{
          var master = null
          Object.values(group).forEach(cn=>{
            cn.children.forEach(n=>{
              if (n.get_value() < state.resolution){
                if(!master)
                  master=n
                else{
                  utils.move_node(n,master)
                  n.filtered=true
                }
              }else{
                if(n.filtered){
                  utils.revert_node(n)
                  delete n.filtered
                }
              }
            })
          })
        })
      })
    },
    runInitialLayout: (state,getters) => {
      var step = state.group_separation
      Object.values(getters.columns).forEach( (column) =>{
        var y = 0.0
        Object.values(column).forEach( (group, gid)=>{
          var vals = Object.values(group)
          vals = vals.sort( (a,b)=>{return b.get_value()-a.get_value() } )
          vals.forEach( (n,id)=>{
            Vue.set(n,'y_position',y)

            y = n.bottom(state)
            if(isNaN(y)) y=0.0

            if(n.children.length)
              y+=state.node_padding
          })
          y-=state.node_padding
          y+=step
        })
      })
    },
    relax(state,getters,amt=.05,iters=20){

      for(var j=0;j<iters;++j){
        //TODO: start from left and follow downstreams for each node?
        // essentially balance "flows" along x individually
        Object.values(state.nodes).forEach( n=>{
          var cc=0
          cc+=n.y_position

          n.source_links.forEach(l=>{
            cc += (l.target.parent.y_position-cc)*amt*l.value
          })

          n.target_links.forEach(l=>{
            cc += (l.source.parent.y_position-cc)*amt*l.value
          })


          Vue.set(n,'y_position',cc)
        })
        if(j%5){
          Object.keys(getters.columns).forEach( (k,id) =>{
            var column = getters.columns[k]
            var column_vals = Object.values(column)
            helpers.fixup_column(state,column)
            column_vals.forEach( g => { helpers.fixup_group(state,g) } )
          })
        }
      }
      Object.keys(getters.columns).forEach( (k,id) =>{
        var column = getters.columns[k]
        var column_vals = Object.values(column)
        helpers.fixup_column(state,column)
        column_vals.forEach( g => { helpers.fixup_group(state,g) } )
        helpers.fixup_column(state,column)
      })
    },
    scaleNode: (state,payload) =>{
      var n = payload
      n.source_links.forEach( l=>{
        l.value*=.5
      })
      n.target_links.forEach( l=>{
        l.value*=.5
      })
    },
    duplicateNode: (state,payload) =>{
      var nn = utils.duplicate_node(state.nodes,payload.node,payload.name)
      Vue.set(state.nodes,nn.index,nn)
      Vue.set(state.node_by_name,nn.children[0].name,nn.children[0])
    },
    set_selected_tags(state,payload){
      state.selected_tags = payload
    },
    set_search_term(state,payload){
      var search = payload.toLowerCase()
      state.search_term = search
      var searched = []
      Object.values(state.nodes).forEach( cn=>{
        cn.children.forEach( n=>{
          var val = n.search_match(search)
          Vue.set(n,'is_searched',val)
          if(val)
            searched.push(n)
        })
      })

      searched.forEach(sn=>{
        utils.flowUpstream(sn,'is_searched')
        utils.flowDownstream(sn,'is_searched')
      })
    },

    set_dirty(state,payload){
      state.dirty = payload
    },

    set_color_type(state,payload){
      state.color_type = payload
    },

    set_dataset(state,payload){
      state.dataset = payload
    },
    setCurrentNode(state,payload){
      state.cur_node = payload
    },
    setUpDown(state,payload){
      Object.values(state.nodes).forEach(cn=>{cn.children.forEach(n=>{n.is_updown=false})})
      state.up_down = payload
      if(state.up_down!=null){
        state.up_down.children.forEach( n=>{
          n.is_updown=true
          utils.flowUpstream(n,'is_updown')
          utils.flowDownstream(n,'is_updown')
        })
      }
    },
    hover(state,payload){
      state.hover = payload
    },
    modify_efficiency(state,payload){
      var n = payload.node
      n.waste_percentage=payload.value

      var special = n.source_links.filter(l=>{ return (l.target.name.includes("*energy services*") || l.target.name.includes("*waste*")) ? true : false } )
      console.assert(special.length === 2)
      special.sort( l=>{return l.target.name.includes("waste") ? -1e9 : 1e9})
      var prev = special[0].value+special[1].value
      Vue.set(special[0],'value',n.waste_percentage*prev)
      Vue.set(special[1],'value',(1.-n.waste_percentage)*prev)
      state.dirty = true
    },
    set_export_layer(state,payload){
      state.export_layer=payload
    },
    resort(state){
      Object.values(state.nodes).forEach( (cn)=>{
        cn.children.forEach( (n) =>{
          function sorting (l) {
            if (l.source.name.includes("*waste*")) return 9e9
            if (l.source.name.includes("*energy services*")) return -9e19
            if (l.source.name.includes("*")) return 9e9


            return l.target.parent.y_position +
              l.target.parent.relative_y_positions()[l.target.index]

          }

          n.source_links.sort( (a,b)=>{return sorting(a) - sorting(b)})
          if(n.name.includes("*")){
            n.target_links.sort( (a,b)=>{return sorting(b) - sorting(a)})
          }
        })
      })
    }
  }
})



//////////////////
// WEBPACK FOOTER
// ./src/store/index.js
// module id = null
// module chunks = 